

// export const baseUrl = 'https://devapi.needu.in/api/'
// export const baseUrl = 'https://api.needu.in/api/'

// export const baseUrl = 'http://localhost:3200/api/'
export const baseUrl = 'https://api.bankmudraa.com/api/'

// dev branch
// export const baseUrl = 'https://dev.bankmudraa.com/api/'

export const baseUrlImage = 'https://devapi.needu.in/api/cloudinary/'
// export const baseUrlImage = 'https://api.needu.in/api/cloudinary/'
export const baseUrVideos = 'https://devapi.needu.in/api/cloudinary/video/'
// export const baseUrVideos = 'https://api.needu.in/api/cloudinary/video/'
